import demoVideos from 'utils/demoVideos';

const demoVideoIds = demoVideos.map((x) => x.videoId);

export default function isDemoVideo({ videoId }: { videoId: string }) {
  return demoVideoIds.includes(videoId);
}
